import React, { useState } from 'react'
import { Box, Typography, Button, Collapse, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface AccountsListProps {
  accounts: string[]
  maxItems?: number
}

const AccountsList: React.FC<AccountsListProps> = ({ accounts, maxItems = 3 }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const [expanded, setExpanded] = useState(false)

  if (!accounts || accounts.length === 0) return null

  const remainingCount = accounts.length - maxItems

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
        <Box sx={{
          overflow: 'hidden',
          flex: 1
        }}>
          {!expanded && (
            <Typography component="span" sx={{
              fontSize: 11,
              color: theme.palette.text.primary,
              display: 'block',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}>
              {accounts.slice(0, maxItems).join(', ')}
              {remainingCount > 0 && `, ... + ${remainingCount}`}
            </Typography>
          )}

          <Collapse in={expanded} timeout={300}>
            <Typography sx={{ fontSize: 11, color: theme.palette.text.primary }}>
              {accounts.join(', ')}
            </Typography>
          </Collapse>
        </Box>

        {remainingCount > 0 && (
          <Button
            size="small"
            onClick={() => setExpanded(!expanded)}
            sx={{
              ml: 2,
              fontSize: 9,
              minWidth: '70px',
              color: theme.palette.text.secondary,
              backgroundColor: '#EFEFEF',
              borderRadius: '4px',
              padding: '2px 8px',
              '&:hover': {
                backgroundColor: '#E0E0E0',
              }
            }}
          >
            {expanded
              ? t('auth.history.see_less', 'Voir moins')
              : t('auth.history.see_more', 'Voir plus')
            }
          </Button>
        )}
      </Box>
    </Box>
  )
}

export default AccountsList
